import Vue from "vue";
import Vuex from 'vuex'

import adminUser from './adminUser'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user: adminUser
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js